import styled from '@emotion/styled';

import { BasicFlex, InputLabel, LabelUpper } from '../../../utils/Common';

import { SearchPanel, ReportButton, ResultPanel, SummaryCard, SummaryAmount, TrajectoryIndicator, FilterRibbon, TopCountTable, TopCountTableDescription, TopCountTableHeader, TopCountTableRow, TopCountTableTitle } from '../Common';

import { Grid, Button, useTheme, Card, CardContent, CardHeader, Divider } from '@mui/material';

import AutoCompleteMulti from '../FilterFormComponents/AutocompleteMulti';
import DateRangePicker from '../FilterFormComponents/DateRangePicker';
import DatePicker from '../FilterFormComponents/DatePicker';

import useReportStore from '../../../store/reports';

import { formatCurrency } from '../../../utils/util';

import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import Donut from '../../../utils/utilities/Charts/DonutChart';

import Lottie from '../../../utils/Lotties';
import LoadReportAnimation from '../../../assets/animations/Chart Grow Up.json';


const SummaryCards = styled(BasicFlex)`

`;

const Categories = styled(Card)`
  
`

const CatAmount = styled.div`
  font-weight: 500;
  font-size: 1.3rem;
`

const CatPer = styled.div`
  color: ${props => props.theme.colors.lightText};
`

const categoryInfoLabel = (item, total) => {
  return (
    <BasicFlex gap=".6rem">
      <CatAmount>{formatCurrency(item.value)}</CatAmount> <CatPer>{Math.round((item.value / total) * 100)}%</CatPer>
    </BasicFlex>
  )
}

const TopHeadersByType = [
    {
      id: "name",
      label: "Repair Type",
      align: "left",
    },
    {
      id: "total_cost",
      label: "Cost",
      align: "center",
      currency: true
    },
    {
      id: "total_price",
      label: "Price",
      align: "center",
      currency: true
    },
    {
      id: "count",
      label: "Total Count",
      align: "center",
    },
    {
      id: "total_minutes",
      label: "Time Worked (Min)",
      align: "right",
    },
]

const TopHeadersBySpecialist = [
  {
    id: "specialist",
    label: "Specialist",
    align: "left",
  },
  {
    id: "total_cost",
    label: "Cost",
    align: "center",
    currency: true
  },
  {
    id: "total_price",
    label: "Price",
    align: "center",
    currency: true
  },
  {
    id: "count",
    label: "Total Count",
    align: "center",
  },
  {
    id: "total_minutes",
    label: "Time Worked (Min)",
    align: "right",
  },
]

const RepairReport = () => {
  const reportType = useReportStore(state => state.reportType);
  const filters = useReportStore(state => state.filters);
  const staticFilters = useReportStore(state => state.staticFilters);
  const reportResults = useReportStore(state => state.reportResults);
  const reportLoading = useReportStore(state => state.reportLoading);

  let dateRange = staticFilters[reportType]?.date || "";
  let customDate = dateRange === "Custom" ? true : false;
  console.log(filters, "filters");

  console.log(reportResults, "reportResults");

  const isLoading = reportLoading[reportType];
  const results = reportResults[reportType];

  let totals = results?.totals || {};
  let repair_types = results?.by_type || [];
  let work_by_specialist = results?.by_specialist || [];

  const theme = useTheme();

  return (
    <>
    <SearchPanel>
      <Grid container spacing={2}>

        <Grid size={{xs: 12, md: 4}}>
          <InputLabel>Date Range</InputLabel>
          <DateRangePicker 
            field="created_at" 
          />
        </Grid>

       {customDate ? <Grid size={{xs: 12, md: 2}}>
          <InputLabel>Date From</InputLabel>
          <DatePicker 
            field="created_at" 
            type="start"
          />
        </Grid> : null}

        {customDate ? <Grid size={{xs: 12, md: 2}}>
          <InputLabel>Date To</InputLabel>
          <DatePicker 
            field="created_at" 
            type="end"
          />
        </Grid> : null}

        <Grid size={{xs: 12, md: 4}}>
          <InputLabel>Repair Category</InputLabel>
          <AutoCompleteMulti 
            field="rp.category" 
            url="repairs/repair_categories"
            fieldOptions={{fieldName: "name"}}
            prefetch={true}
          />
        </Grid>

        <Grid size={{xs: 12, md: 4}}>
          <InputLabel>Repair Status</InputLabel>
          <AutoCompleteMulti 
            field="status" 
            values={[{value: "scheduled", label: "Scheduled"}, {value: "completed", label: "Completed"}, {value: "canceled", label: "Canceled"}]}
            fieldOptions={{fieldName: "value", displayField: "label"}}
          />
        </Grid>

        <Grid size={{xs: 12}}>
          <ReportButton />
        </Grid>

      </Grid>
      
    </SearchPanel>

    <FilterRibbon />

    {isLoading ? <Lottie lottieFile={LoadReportAnimation} /> : null}

    {results && !isLoading ? <ResultPanel>
      <SummaryCards gap="2rem" justify="center">

        <SummaryCard $color={theme.colors.info} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Total Cost</LabelUpper>
          <SummaryAmount>{formatCurrency(totals.total_cost)}</SummaryAmount>
          <TrajectoryIndicator value={12} />
        </SummaryCard>

        <SummaryCard $color={theme.colors.success} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Total Price</LabelUpper>
          <SummaryAmount>{formatCurrency(totals.total_price)}</SummaryAmount>
          <TrajectoryIndicator value={8.5} />
        </SummaryCard>

        <SummaryCard $color={theme.colors.warning} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Avg. Repair Price</LabelUpper>
          <SummaryAmount>{formatCurrency(totals.avg_price)}</SummaryAmount>
          <TrajectoryIndicator value={-4.2} />
        </SummaryCard>

        <SummaryCard $color={theme.colors.secondary} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Total Repairs</LabelUpper>
          <SummaryAmount>{totals.count}</SummaryAmount>
          <TrajectoryIndicator value={0} />

        </SummaryCard>

      </SummaryCards>

      <BasicFlex gap="2rem" align="flex-start">
        <TopCountTable headers={TopHeadersByType} data={repair_types}>
          <TopCountTableDescription>
            <TopCountTableTitle>Top Repairs</TopCountTableTitle>
            <SimpleChip label="By Repair Count" />
          </TopCountTableDescription>

        </TopCountTable>

        <TopCountTable headers={TopHeadersBySpecialist} data={work_by_specialist}>
          <TopCountTableDescription>
            <TopCountTableTitle>Top Specialists</TopCountTableTitle>
            <SimpleChip label="By Work Logged" />
          </TopCountTableDescription>

        </TopCountTable>
      </BasicFlex>

      <Categories elevation={3} sx={{width: "100%", borderRadius: "8px"}}>
        <CardHeader subheader="Total Price by Repair Type" />
        <Divider />
        <Donut data={repair_types} additionalInfoLabel={categoryInfoLabel} />
      </Categories>

    </ResultPanel> : null}
    </>
  )
};

export default RepairReport;